export default __webpack_public_path__ + "static/media/FloridaPanthers.45c6b3e4.svg";